var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotelBuild = function SvgHotelBuild(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16h2v2H0v-2h2V1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v15h4V8h-2V6h3a1 1 0 0 1 1 1v9ZM4 2v14h8V2H4Zm2 6h4v2H6V8Zm0-4h4v2H6V4Z",
    fill: "#E96358"
  })));
};
export default SvgHotelBuild;